export const validateEmail = (email) => {
  var reg =
    "^[a-zA-Z0-9]+(.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(.[a-zA-Z0-9-]+)*(.[a-zA-Z]{2,15})$";
  if (!email.match(reg)) {
    return false;
  }
  return true;
};
